module.exports = __webpack_public_path__ + "abe733b320012dbd243221c5e65de708.svg";